module.exports = __webpack_public_path__ + "static/HomeandBlissRenoLogo-1de12fd6aab1e2469867265dba4ae53e.png";